import React from 'react';
import {Link} from 'react-router-dom';
import classNames from 'classnames';
import {Logo} from 'components/svgs/NonLoggedUserLogo';
import {withRouter} from 'react-router-dom';
import clickOutside from 'react-click-outside';
import {inject, observer } from 'mobx-react';
import {IACP_LOGO} from 'constants/sponsor_logos';
import {ONLINE_WORKSHOPS,
  REGULAR_WORKSHOPS,
  THERAPY_PROVIDERS
  } from 'stores/WorkshopsUrlConstants'

const canShowLinksToWorkshopLinkList = [
  '/',
  'online_workshops',
  'regular_workshops',
  'provider_bios'
]

@withRouter
@inject('SponsorStore')
@observer
export default class UserNonLoggedInNavbar extends React.Component {


  state = {
    openedHamburger: false,
    canShowLinksToWorkshop: false,
  };

  openHamburger = () => {
    this.setState({openedHamburger: true});
  };

  closeHamburger = () => {
    this.setState({openedHamburger: false})
  };

  componentDidMount = () => {
    this.handleCanShowlinks(location)
    this.routerListener = this.props.history.listen((location) => {
      this.setState({openedHamburger: false})
      this.handleCanShowlinks(location)
    });
  };

  componentWillUnmount = () => {
    this.routerListener();
  };

  redirectOnline = () => {
    this.props.history.replace('/online_workshops', {cpd_hours: true});
  };

  redirectOther = () => {
    this.props.history.replace('/online_workshops', {other: true});
  };

  redirectToGroup = () => {
    this.props.history.replace('/online_workshops', {group: true});
  };

  redirectToPublic = () => {
    this.props.history.replace('/online_workshops', {public: true});
  }

  redirectToOrganizations = () => {
    this.props.history.replace('/online_workshops', {organizations: true});
  }

  redirectToRegular = () => {
    this.props.history.push('/regular_workshops')
  }

  redirectProviderBios = () => {
    this.props.history.push('/provider_bios')
  }

  redirectToLive = () => {
    this.props.history.push('/online_workshops', {webinar: true});
  }

  redirectToOnline = () => {
    this.props.history.push('/online_workshops', {online: true});
  }

  handleCanShowlinks(location){
    if(canShowLinksToWorkshopLinkList.some(link=>location.pathname.includes(link)))
      this.setState({canShowLinksToWorkshop: true})
    else  this.setState({canShowLinksToWorkshop: false})
  }

  render() {
    const {sponsorId} = this.props.SponsorStore;
    const {isNavbarStatic} = this.props;
    const canShowLinksToWorkshop = () => {
      if (this.state.canShowLinksToWorkshop) {
        return (
          <div className="workshop-wrapper sub-menu-wrapper" style={{padding: '22px', justifyContent: 'center', backgroundColor: '#0a2535', margin: '12px 0 0'}}>
            {/* <span className="add-workshop nav-btn btn prime bordered" onClick={this.redirectOnline}>Online workshops</span>
            <span className="add-workshop nav-btn btn bordered black" onClick={this.redirectProviderBios}>Provider bios</span>
            <span className="add-workshop nav-btn btn bordered blue" onClick={this.redirectToRegular}>Regular workshops</span> */}
            <span
              className="add-workshop"
              style={{border: 0}}
              onClick={this.redirectToLive}
            >
              LIVE WEBINARS
            </span>
            <span
              className="add-workshop"
              style={{border: 0}}
              onClick={this.redirectToOnline}
            >
              ONLINE WORKSHOPS
            </span>
            <span
              className="add-workshop"
              style={{border: 0}}
              onClick={this.redirectToGroup}
            >
              Public Webinars
            </span>
            <span
              className="add-workshop"
              style={{border: 0}}
              onClick={this.redirectToPublic}
            >
              Public Workshops
            </span>
            <span
              className="add-workshop"
              style={{border: 0}}
              onClick={this.redirectToOrganizations}
            >
              Organisations
            </span>
          </div>
        );
      }
    }

    const regularNavbar = (
      <div
        className="main-menu-wrapper col-md-1"
        style={{
          alignSelf: 'center',
        }}
      >
        <div className="menu" style={{alignItems: 'center'}}>
          {/* <Link to="/create_course_online" className="add-workshop">
            CREATE YOUR WORKSHOP ONLINE
            <br /><span>it's free</span>
          </Link> */}
          <span className="hamburger" onClick={this.openHamburger}>
            <span className="hamburger">
              <i className="ic-menu-ico"/>
            </span>
          </span>
        </div>
        <Bar active={this.state.openedHamburger} closeHamburger={this.closeHamburger} history={this.props.history}/>
      </div>
    )

    const topLinks = () => {
      return (
        <div className="workshop-wrapper col-5 col-md-6">
          <Link
            to="/"
            className="logo"
            style={{alignSelf: 'center'}}
          >
            {Logo}
          </Link>
          <Link to="/about-us" className="add-workshop hide_mobile" style={{border: 0}}>
            About<br />Us
          </Link>
          <Link to="/our_services" className="add-workshop hide_mobile" style={{border: 0}}>
            Our<br />Services
          </Link>
          <Link to="/organisations-info" className="add-workshop hide_mobile" style={{border: 0}}>
            Organisational<br />Learning
          </Link>
          <Link to="/create_course_online" className="add-workshop hide_mobile" style={{border: 0}}>
            Create<br />Workshop
          </Link>
          <Link to="/newuser/signin" className="add-workshop" style={{border: 0, color: '#daa609', margin: 0}}>
            Log<br />In
          </Link>
          <Link to="/newuser/signup" className="add-workshop" style={{border: 0, color: '#daa609', margin: 0}}>
            Sign<br />Up
          </Link>
          {!sponsorId && regularNavbar}
        </div>
      );
    }

    const linksTo = canShowLinksToWorkshop();
    const topLinksTo = topLinks();
    let notSponsor = [topLinksTo];

    const sponsorLogo = (
      <div className="spons-logo">
        <Link to='/iacp'>
          <img src={IACP_LOGO} alt="IACP"/>
        </Link>  
      </div>
    )

    const styles = isNavbarStatic ? {position: 'fixed'} : {};
    return (
      <header className="main-header" style={styles}>
        <div className="container-fluid">
          <div className="row justify-content-between">
            {/* <div className="logo-wrapper col-4 col-md-2" style={{display: 'flex', alignItems: 'center'}}>
              <Link
                to="/"
                className="logo"
                style={{alignSelf: 'center'}}
              >
                {Logo}
              </Link>
            </div> */}

            {sponsorId ? sponsorLogo : notSponsor }
             
          </div>
          <div className="row justify-content-center hide_mobile">
            {linksTo}
          </div>
        </div>
      </header>
    );
  }
}


@clickOutside
class Bar extends React.Component {

  state = {active: false };

  componentWillReceiveProps = newProps => {
    this.setState({active: newProps.active})
  };

  handleClickOutside = (evt) => {
    this.props.closeHamburger()
  };

  redirectToLive = () => {
    this.props.history.push('/online_workshops', {webinar: true});
  }

  redirectToOnline = () => {
    this.props.history.push('/online_workshops', {online: true});
  }

  redirectToGroup = () => {
    this.props.history.replace('/online_workshops', {group: true});
  };

  redirectToPublic = () => {
    this.props.history.replace('/online_workshops', {public: true});
  }

  redirectToOrganizations = () => {
    this.props.history.replace('/online_workshops', {organizations: true});
  }

  render(){
    return(
      <div className={classNames({sidebar: true, active: this.state.active}) }>
        <div className="auth-holder mobile-auth">
          <Link to="/newuser/signin" className="btn prime bordered">Sign in</Link>
        </div>
        <div className="auth-holder border mobile-auth">
          <Link to="/newuser/signup" className="btn grey bordered empty">SIGN UP</Link>
        </div>
        <ul className="sidebar-workshop-list border">
          <li>
            <span to="/online_workshops" onClick={this.redirectToLive} className="work-item online">LIVE WEBINARS</span>
          </li>
          <li>
            <span to="/online_workshops" onClick={this.redirectToOnline} className="work-item online">ONLINE WORKSHOPS</span>
          </li>
          <li>
            <span to="/online_workshops" onClick={this.redirectToGroup} className="work-item online">PUBLIC WEBINARS</span>
          </li>
          <li>
            <span to="/online_workshops" onClick={this.redirectToPublic} className="work-item online">PUBLIC WORKSHOPS</span>
          </li>
          <li>
            <span to="/online_workshops" onClick={this.redirectToOrganizations} className="work-item online">ORGANISATIONS</span>
          </li>
          <li>
            <Link to="/create_course_online" className="work-item online">CREATE WORKSHOP</Link>
          </li>
          <li>
            <Link to="/our_services" className="work-item online">OUR SERVICES</Link>
          </li>
          <li>
            <Link to="/organisations-info" className="work-item online">ORGANISATIONAL LEARNING</Link>
          </li>
          <li>
            <Link to="/about-us" className="work-item online">ABOUT US</Link>
          </li>
          <li>
            <Link to="/provider_bios" className="work-item online">PROVIDER BIOS</Link>
          </li>
          {/* <li>
            <Link to="/regular_workshops" className="work-item regular">REGULAR WORKSHOPS</Link>
          </li>
          <li>
            <Link to="/createworkshop" className="add-workshop">
              CREATE YOUR WORKSHOP ONLINE
              <br /><span>it's free</span>
            </Link>
          </li> */}
        </ul>
        {/* <div className="auth-holder">
          <Link to="/organisations-info" className="btn prime bordered" style={{maxWidth: '260px'}}>ORGANISATION WORKSHOP INFO</Link>
        </div> */}
        <ul className="sidebar-list border">
          {/* <li>
            <Link to="/about-us" className="list-item">
              About Us
            </Link>
          </li> */}
          <li>
            <Link to="/contacts" className="list-item">
              Contact Us
            </Link>
          </li>
          {/* <li>
            <Link to="/termsofconditions" className="list-item">
              Terms of Service
            </Link>
          </li>
          <li>
            <Link to="/providerterms" className="list-item">
              Provider Terms
            </Link>
          </li>
          <li>
            <Link to="/privacypolicy" className="list-item">
              Privacy Policy
            </Link>
          </li>
          <li>
            <Link to="/cookiespolicy" className="list-item">
              Cookies Policy
            </Link>
          </li>
          <li>
            <Link to="/subprocessors" className="list-item">
              Sub-Processors
            </Link>
          </li> */}
        </ul>
        <ul className="social">
          <li><a href="https://www.facebook.com/TherapyAcademy/"  target="_blank" className="fa fa-facebook-square"/></li>
          <li><a href="https://twitter.com/academy_therapy"  target="_blank" className="fa fa-twitter-square"/></li>
          <li><a href="https://www.linkedin.com/company/therapy-academy/" target="_blank" className="fa fa-linkedin-square"/></li>
        </ul>
        <span className="hamburger" onClick={() => this.props.closeHamburger()}>
          <i className="ic-close-ico"/>
        </span>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/UserNonLoggedInNavbar.jsx